{{ templateService.add('loader', loader) }}
{{ templateService.add('defaultRowTable', defaultRowTable) }}
{{ templateService.add('emptyDiv', emptyDiv) }}
{{ templateService.add('defaultRowTableHeader', defaultRowTableHeader) }}

<ng-template #emptyDiv>
  <div class="t-empty"></div>
</ng-template>

<ng-template #loader>
  <app-loader [color]="templateService.colors"></app-loader>
</ng-template>

<ng-template #defaultRowTableHeader let-column="column">
  <ng-container>{{ column.name | locLabel }}</ng-container>
</ng-template>

<ng-template #defaultRowTable let-cell="cell">
  <div class="text-tooltip" *ngIf="isNumberTooltip(cell)">
    <span>{{ cell.displayValue }}</span>
    <mat-icon *ngIf="cell.value > 0" class="mat-primary tooltip-icon" [matTooltip]="cell.tooltip"> info </mat-icon>
  </div>

  <ng-container *ngIf="isButton(cell)">
    <a mat-button [class]="cell.buttonClass" [color]="cell.color" type="button" (click)="cell.handle($event)">
      {{ cell.value | locLabel }}
    </a>
  </ng-container>

  <ng-container *ngIf="isIcon(cell)">
    <mat-icon [color]="cell.color" [matTooltip]="cell.tooltipKey ? (cell.tooltipKey | loc) : ''">{{ cell.value }}</mat-icon>
  </ng-container>

  <ng-container *ngIf="isIconButton(cell)">
    <mat-icon [color]="cell.color" type="button" (click)="cell.handle($event)">{{ cell.value }}</mat-icon>
  </ng-container>

  <div [class]="cell.className" *ngIf="isDate(cell)">{{ cell.value | lDate: cell.format }}</div>

  <div [class]="cell.className" *ngIf="isPhoneNumber(cell)">{{ cell.value | phone: cell.placeholder }}</div>

  <div [class]="cell.className" *ngIf="isLocalized(cell)">
    <ng-container *ngIf="cell.replaceObj; else mods">
      {{ cell.displayValue | locRep: cell.replaceObj }}
    </ng-container>
    <ng-template #mods>
      <ng-container [ngSwitch]="cell.modifiers">
        <ng-container *ngSwitchCase="mod.CAP"> {{ cell.displayValue | locCap }}</ng-container>
        <ng-container *ngSwitchCase="mod.UPPER"> {{ cell.displayValue | locUpper }}</ng-container>
        <ng-container *ngSwitchCase="mod.LOWER"> {{ cell.displayValue | locLower }}</ng-container>
        <ng-container *ngSwitchDefault>{{ cell.displayValue | loc }}</ng-container>
      </ng-container>
    </ng-template>
  </div>

  <ng-container *ngIf="isRentalUnitAdr(cell)">
    <ng-container *ngFor="let unit of cell.displayArray; let last = last">
      <mat-icon inline>{{ unit.icon }}</mat-icon> {{ unit.number }}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isCheckbox(cell)">
    <mat-checkbox
      [ngModel]="cell.checked"
      [disabled]="cell.disabled"
      (ngModelChange)="cell.click($event)"
      (click)="$event.stopPropagation()"
      color="primary"
    ></mat-checkbox>
  </ng-container>

  <ng-container *ngIf="isResidentUser(cell)">
    <div>
      <div>{{ cell.value }}</div>
      <div *ngIf="cell.userName" class="foreground gray">{{ 'label.user' | loc }} {{ cell.userName }}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="isBasic(cell)">{{ cell.displayValue }}</ng-container>
</ng-template>
